<template>
  <div class="infobox">
    <div v-html="center"></div>
  </div>
</template>
<style lang="scss" scoped="true">
.red {
  color: red;
}
.fb {
  font-weight: bold;
  font-size: 32px;
}
.titlebox {
  margin-top: 15px;
  font-weight: bold;
}
.infobox {
  line-height: 45px;
  font-size: 26px;
  margin: 30px 25px;
}
</style>
<script>
import * as InsuranceList from "@/utils/api";
export default {
  data() {
    return {
      center: ""
    };
  },
  mounted() {
    InsuranceList.agreementApi("TRANSPORT").then(res => {
      if (res.content) {
        this.center = res.content;
      }
    });
  }
};
</script>
